import React, { useState } from "react";
import { FiPower } from "react-icons/fi";
import { FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import { formatName } from "../../utils/formatName";
import ConfirmModal from "../../components/confirm-modal/ConfirmModal";

const PowerIcon = FiPower as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const UserIcon = FaUserCircle as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

interface Props {
  setIsAuthenticated: (auth: boolean) => void;
}

const Header: React.FC<Props> = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();

  const [isModalOpen, setModalOpen] = useState(false);

  // Get user info from localStorage
  const adminDetail = localStorage.getItem("adminDetail");
  const user = adminDetail ? JSON.parse(adminDetail) : null;
  const fullName = user ? `${user.firstName} ${user.lastName}` : "User";
  const roleName = user?.roleIds?.roleName || "Role";

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("adminDetail");
    localStorage.removeItem("redirectPath");
    setIsAuthenticated(false);
    navigate("/login");
  };

  return (
    <>
      <header className="header-container">
        <div className="header-left">
          <img
            src="https://www.sos.wa.gov/sites/default/files/2023-03/sos-logo.svg?uid=6853a16092bb8"
            alt="Washington Secretary of State"
            className="headerLogo"
          />
        </div>

        <div className="header-right">
          <div className="user-info">
            <UserIcon className="user-icon" />
            <div className="user-details">
              <div className="user-name">{fullName}</div>
              <div className="user-role">{formatName(roleName)}</div>
            </div>
          </div>
          <button className="logout-button" onClick={() => setModalOpen(true)}>
            Log Out <PowerIcon className="logout-icon" />
          </button>
        </div>
      </header>
      <ConfirmModal
        isOpen={isModalOpen}
        title="Log Out?"
        message="Are you sure you want to log out?"
        confirmText="Yes, Log Out"
        cancelText="Cancel"
        onConfirm={handleLogout}
        onCancel={() => setModalOpen(false)}
      />
    </>
  );
};

export default Header;
